import { Outlet } from "react-router-dom";
import TeacherNavbar from "./TeacherNavbar";

const TeacherLayout = () => {
  return (
    <>
      <TeacherNavbar />
      <div style={{ padding: "20px" }}>
        <Outlet />
      </div>
    </>
  );
};

export default TeacherLayout;